import { TabStrip, TabStripProps } from "./tabStrip.js";
import { Helper } from "../util/helper.js";
import { HTTPService } from "../util/httpManager.js";
import { IndividualDataHelper } from "../util/individualDataHelper.js";
import { FormGenerator } from "./formGenerator.js";
import { Config } from "../config/config.js";
import React from "react";
export default class IndividualData extends React.Component<IndividualDataProps, { metaData, dataSources }>{
    private idHelper = IndividualDataHelper.create();
    private dataProperty: string;
    private individualData: any;
    private individualProperties: Array<string> = [];

    constructor(props: IndividualDataProps) {
        super(props);
        this.dataProperty = "entity.IndividualFields";
        if (Helper.hasValue(props.dataPath))
            this.dataProperty = props.dataPath;
        this.state = {
            metaData: {},
            dataSources: []
        };
        this.initApp();
    }

    private localEval = (expression, prepare = null) => {
        if (this.individualProperties.indexOf(expression) !== -1) {
            return this.individualData[expression];
        } else {
            return this.props.handleEval(expression, prepare);
        }
    }

    private initApp = async () => {
        const key1 = this.props.context.key1;
        let defUrl = `Individual/GetData?id1={{${key1}}}`;
        let key2 = null;
        if (Helper.hasValue(this.props.context.key2)) {
            key2 = this.props.context.key2;
            defUrl += `&id2={{${key2}}}`;
        }

        let key3 = null;
        if (Helper.hasValue(this.props.context.key3)) {
            key3 = this.props.context.key3;
            defUrl += `&id3={{${key3}}}`;
        }

        const context = this.props.context.contextType === "ticket" ? "procedure" : this.props.context.contextType;
        let url = Helper.processTemplate(`${context}${defUrl}`, (match) => {
            let value = this.getKeyValue(match, this.props.entity);
            return encodeURIComponent(value);
        });

        if (!Helper.hasValue(this.props.entity[key1]) && Helper.hasValue(this.props.context.keyVal1))
            url = url.replace("id1=undefined", `id1=${encodeURIComponent(this.props.context.keyVal1)}`)


        const result = await Promise.all([
            HTTPService.get(url),
            Helper.getTranslations(["Standard.Msg.Loeschen", "Standard.Msg.SpeichernFehler", "Standard.Msg.SpeichernErfolgreich", "Standard.OK", "Standard.Neu", "Adresse.Zusatzdaten",
                "Standard.Speichern", "Standard.CloseBtn", "WebSMS.Additional.NData", "WebSMS.Additional.EditNData", "Standard.BitteWählen", "Standard.Editieren", "Standard.Loeschen",
                "Adresse.AdresseSuchen", "Maschine.Maschinensuche", "Projekt.Projektsuche", "Ressource.Ressourcensuche", "Ansprechpartner.Ansprechpartnersuche", "WebSMS.Title.ProcedureSearch", "Standard.Benutzersuche"])
        ]);
        const metaData = result[0].Data;
        const translations = result[1].Data;
        this.processData(metaData, translations);
    }

    private processData = (metaData, translations) => {
        let mixedItems = this.idHelper.getItemsMixedOnMainTabs(this.props.metadata);
        let config = {
            categoryMetadata: metaData.categoryMetadata,
            fieldsMetadata: metaData.metadata
        };
        let tmpMeta = this.idHelper.createMetadata(config, translations["Adresse.Zusatzdaten"], "individualMetadata", true, translations, mixedItems, false, (this.props.entity as any).RueckreiseModusActivated, this.props.sideBySide);

        this.individualData = this.getKeyValue(this.dataProperty, this.props.entity);
        this.individualProperties = Object.keys(this.individualData);

        ////////////////////////////////////////////////////////////////////////////////////
        //tmpMeta.gui.tabs[0].regions[0].fields[1].required = true;///////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////
        this.props.handleIndividulFieldsMetaDataCreated(tmpMeta.gui);
        this.setState({ metaData: tmpMeta.gui, dataSources: tmpMeta.dataSources });
    }

    private getKeyValue(key: string, entity: any) {
        let keyParts = key.split(".");
        for (let i = 1; i < keyParts.length; ++i) {
            if (!Helper.hasValue(entity))
                return null;
            entity = entity[keyParts[i]];
        }
        return entity;
    }

    handleOnChange = (field, value, dataItem) => {
        let f = this.dataProperty + "." + field.model;
        this.props.onChange($.extend({}, field, { model: f, RecordRight: null }), value, dataItem);
    }

    render() {
        let cmp: any = false;
        if (this.individualData) {
            this.individualData.RecordRight = { ...this.props.entity.RecordRight };

            if (this.props.readonly) {
                this.individualData.RecordRight.CanWrite = false;
            }
        }
        if (Helper.hasValue(this.state.metaData.tabs)) {
            if (!Config.settings.isMobileApp) {
                cmp = <div className="flex-container__item flex-container">
                    <TabStrip metadata={this.state.metaData} entity={this.individualData} horizontal={true}
                        dataSources={this.state.dataSources} context={this.props.context}
                        onChange={this.handleOnChange} onDataLoaded={this.props.onDataLoaded} handleEval={this.localEval}
                        handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                        handleIndividulFieldsMetaDataCreated={this.props.handleIndividulFieldsMetaDataCreated}
                        commandManager={this.props.commandManager}></TabStrip>
                </div>
            } else {
                let regions = []
                for (let tab of this.state.metaData.tabs) {
                    for (let region of tab.regions) {
                        region.title = tab.title;
                        region.size = [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "12/12"
                            },
                            {
                                container: "large",
                                width: "12/12"
                            },
                            {
                                container: "extralarge",
                                width: "12/12"
                            }
                        ];
                        regions.push(region);
                    }
                };

                cmp = <div className={"flex-container__item"}>
                    <FormGenerator regions={regions} entity={this.individualData}
                        dataSources={this.state.dataSources} context={this.props.context} onChange={this.handleOnChange} onDataLoaded={this.props.onDataLoaded}
                        handleEval={this.localEval} handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel} commandManager={this.props.commandManager}>
                    </FormGenerator>
                </div>
            }
        }
        return (cmp);
    }
};

interface IndividualDataProps extends TabStripProps {
    dataPath: string;
    readonly: boolean;
    sideBySide?: boolean;
}